import { Tag } from './tag';

const setStyles = (
  element: HTMLElement,
  styles: Partial<CSSStyleDeclaration>,
) => {
  for (let k in styles) {
    element.style.setProperty(k, styles[k] as string);
  }

  return element;
};

export const positionAdvert = (tag: Tag) => {
  const { creativeContainer, payload } = tag;

  if (payload!.creative.proFormat) {
    setStyles(creativeContainer!, {
      position: 'absolute',
      // center this container relative to the parent
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
    });
  }

  return tag;
};
